'use strict';
import React from 'react';
import {createEventHandler, mapPropsStream} from 'recompose';
import {Observable} from 'rxjs';
import {buildInjector} from '../../../_libs/angular-utils';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {logger} from '../logger';
import {TaskItemView} from './TaskItemView';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'UserPinDomain',
]);

// Work in progress
export const StreamedComponent = (props$) => {
  const {
    handler: onTogglePin,
    stream: togglePin$,
  } = createEventHandler();

  const state$ = props$
    .distinctUntilChanged(modelIdPropsAreEqual)
    // Reset the state if the model changes
    .switchMap(() =>
      togglePin$
        .do(e => e.stopPropagation())
        .withLatestFrom(props$)
        .filter(([e, props]) => props.model)
        .takeUntil(props$.last())
        .switchMap(([e, props]) => {
          const currentStatus = props.model.isPinned;
          return Observable
            .merge(
              // Initialize the working state
              Observable.of({
                isPinning: true,
              }),
              // In parallel, dispatch the update request
              Observable.fromPromise(dependencies.UserPinDomain.togglePin(props.model))
                .switchMap(() =>
                  Observable
                    .merge(
                      // Wait for the model to be updated
                      props$
                        .map(props => props.model.isPinned)
                        .distinctUntilChanged()
                        .filter(modelStatus => modelStatus !== currentStatus),
                      // Time out after 4 minutes
                      Observable
                        .timer(240000),
                    )
                    .take(1)
                    .mapTo({isPinning: false})
                )
                .catch(() => Observable.of({isPinning: false})),
            );
        })
        .startWith({
          isPinning: false,
        })
        .scan((acc, curr) => ({
          ...acc,
          ...curr,
        }))
    )
    .catch(epicErrorHandler(logger, 'StreamedComponent'));

  return props$
    .distinctUntilChanged()
    .combineLatest(
      state$,
      (props, state) => ({
        ...props,
        isPinning: state.isPinning,
        onTogglePin,
      }));
};

export const TaskItemContainer = mapPropsStream(StreamedComponent)(TaskItemView);

TaskItemContainer.messages = TaskItemView.messages;
TaskItemContainer.messageProps = TaskItemView.messageProps;

function modelIdPropsAreEqual(a, b) {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  } else {
    return getId(a.model) === getId(b.model);
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskItem/TaskItemContainer.js